import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import CSSModules from 'react-css-modules';
import styles from './table.css';
import { connect } from 'react-redux';

import { setDisplayedReleases } from '../../utils/displayedReleases';
import { RowDetails, RowExpanded } from './';

class TableRows extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedRows: [],
    };
  }

  toggleRow(index) {
    let { expandedRows } = this.state;

    if (_.indexOf(expandedRows, index) > -1) {
      expandedRows = _.pull(expandedRows, index);
    } else {
      expandedRows.push(index);
    }

    this.setState({
      expandedRows: expandedRows,
    });
  }

  isDisplayed(row) {
    const { fullRelease, platform, displayAllVersions } = this.props;

    return (
      (row.release === fullRelease || (row.alwaysVisible || displayAllVersions)) &&
      (row.platform === platform || /^DSVA/.test(row.platform))
    );
  }

  render() {
    const { expandedRows } = this.state;
    let numDisplayedReleases = 0;

    if (
      window.location.pathname === '/software-long-term-support.html' ||
      window.location.pathname === '/ja-jp/software-long-term-support.html' ||
      window.location.pathname === '/software.html' ||
      window.location.pathname === '/ja-jp/software.html'
    ) {
      numDisplayedReleases = setDisplayedReleases(this.props.productTree, 'LTS');
    } else if (
      window.location.pathname === '/software-feature-releases.html' ||
      window.location.pathname === '/ja-jp/software-feature-releases.html'
    ) {
      numDisplayedReleases = setDisplayedReleases(this.props.productTree, 'FR');
    }

    let rowLength = this.props.rowLength;
    let toggleRow = this.toggleRow.bind(this);
    let isDisplayed = this.isDisplayed.bind(this);

    let displayedRows = 1;

    const rows = this.props.rows.map(function(row, index) {
      let display = isDisplayed(row);
      let background = '#fff';

      if (display) {
        if (displayedRows % 2 === 0) {
          background = '#f4f4f4';
        }
        displayedRows++;
      }

      let product = row.product;
      let platform = row.platform;

      if (displayedRows <= numDisplayedReleases[product][platform] + 1) {
        return [
          <RowDetails
            key={`row-${index}`}
            row={row}
            expanded={_.indexOf(expandedRows, index) > -1}
            display={display}
            toggleRow={toggleRow}
            index={index}
            background={background}
          />,
          <RowExpanded
            key={`row-expanded-${index}`}
            row={row}
            expanded={_.indexOf(expandedRows, index) > -1}
            display={display}
            background={background}
            rowLength={rowLength + 1} // Add 1 to offset 'colSpan: 2' on the Software header
          />,
        ];
      }
    });

    return <tbody styleName="table">{rows}</tbody>;
  }
}

TableRows.propTypes = {
  rows: PropTypes.array.isRequired,
  displayAllVersions: PropTypes.bool.isRequired,
  fullRelease: PropTypes.string.isRequired,
  platform: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  productTree: state.softwareFeed.productTree,
});
export default connect(mapStateToProps)(CSSModules(TableRows, styles));
